<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="modal-dialog-scrollable-general">
          <div class="modal-header">
            <div class="col-md-12 d-flex justify-content-between modal-header-border">
              <div>
                <div class="modal-title-new">
                  Correção da ordem para nova análise
                </div>
              </div>

              <div (click)="closeModal()" class="close-icon tappable align-self-center">
                <img src="assets/image/close-modal-icon.svg" />
              </div>
            </div>
          </div>

          <div class="modal-body-content">
            <div class="modal-subtitle-new">
              Anexe a documentação que suporta sua operação.
            </div>
            <input #fileSelector type="file" [multiple]="true" style="display: none" (change)="selectFile($event)">
            <div *ngIf="selectedFiles.length == 0" appDrag (files)="filesDropped($event)" (click)="fileSelector.click()"
              class="row glass tappable">
              <div class="col-12">
                <p class="text-center mb-5">
                  <mat-icon svgIcon="cloud-upload"></mat-icon>
                </p>
                <p class="upload-disclaimer text-center mb-1">Arraste a ordem para cá ou <span
                    class="upload-disclaimer highlighted">busque nos
                    seus
                    arquivos</span>
                </p>
                <p class="description text-center mb-0">Apenas os formatos .pdf .doc .png e .jpg são aceitos
                </p>
              </div>
            </div>
          
            <div *ngIf="selectedFiles.length > 0" class="row glass filled">
              <div class="col-12">
                
                <ul>
          
                  <div class="list-files" *ngFor="let file of selectedFiles; let i = index">
          
                    <div class="file-name">
                      <mat-icon svgIcon="file"></mat-icon>
                      <span  [matTooltip]="file.file.name">{{ file.file.name }}</span>
            
                    </div>
                   
          
                    <div class="btn-remove-file">
                      <button (click)="removeFile(i)" mat-button class="button danger">Remover documento</button>
          
                    </div>
                  </div>
          
                  <div class="d-flex justify-content-between align-items-center add-document">
                    <span class="btn-blue" (click)="fileSelector.click()">Adicionar mais documentos</span>
                    <p class="description text-center mb-0">Apenas os formatos .pdf .doc .png e .jpg são aceitos
                    </p>
                  </div>
                </ul>
              </div>
            </div>
          </div>

          <div class="modal-footer-new" [style.justify-content]="'space-between'">
            <button type="button" [style.width]="'134px'" class="btn-outline-dark btn" type="button">
              Cancelar
            </button>
            <button type="button" [disabled]="selectedFiles.length == 0 || loading" (click)="openGenerateSuccessModal()"
              class="btn-footer btn btn-dark-primary-blue" type="button">
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>